import {
  AutomatedReviewLog,
  AutomatedReviewLogChannel,
} from 'models/automation/Reviews';
import useAddEditReviewTemplateModal from '../../../guestReviewTemplates/modal/useAddEditReviewTemplateModal';

const useActionManualAutomatedReviewLog = () => {
  const { openEditReviewTemplateModal } = useAddEditReviewTemplateModal();

  const manualReviewAutomatedReviewLog = ({
    automatedReviewLog,
  }: {
    automatedReviewLog: AutomatedReviewLog;
  }) => {
    const manualReviewPayload = {
      reviewTemplateUid: automatedReviewLog.reviewTemplateUid,
      leadUid: automatedReviewLog.guest.uid,
      propertyUid: automatedReviewLog.property.uid,
    };
    const isVrbo =
      automatedReviewLog.channel === AutomatedReviewLogChannel.VRBO;

    openEditReviewTemplateModal({
      reviewTemplateUid: automatedReviewLog.reviewTemplateUid,
      manualReviewPayload,
      isVrbo,
      customModalId: isVrbo
        ? 'manual-review-vrbo-automated-review-log-modal'
        : 'manual-review-automated-review-log-modal',
    });
  };

  return {
    manualReviewAutomatedReviewLog,
  };
};

export default useActionManualAutomatedReviewLog;
